var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "address-container",
    class: {
      noShake: _vm.noShake
    }
  }, [_c('input', {
    staticClass: "address-input",
    class: _vm.inputClass,
    attrs: {
      "id": "new-address",
      "name": "new-address",
      "autocomplete": "address-line1",
      "placeholder": "Address 1",
      "type": "text",
      "data-action": "ignore"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onFieldFocus,
      "keyup": _vm.onFieldChange,
      "blur": _vm.onFieldBlur
    }
  }), _vm._v(" "), _vm.autocompleteResult && _vm.autocompleteResult.length > 0 ? _c('div', {
    staticClass: "address-list-container"
  }, _vm._l(_vm.autocompleteResult, function (result, x) {
    return _c('div', {
      key: x,
      staticClass: "address-list-item",
      attrs: {
        "data-action": "ignore"
      },
      on: {
        "click": () => {
          _vm.onSelectAddressHandler(result);
        }
      }
    }, [_c('span', {
      attrs: {
        "data-action": "ignore"
      }
    }, [_vm._v(_vm._s(result.streetLine) + ",")]), _vm._v(" "), result.secondary && result.secondary.length > 0 ? _c('span', {
      attrs: {
        "data-action": "ignore"
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(result.secondary) + ",\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
      attrs: {
        "data-action": "ignore"
      }
    }, [_vm._v(_vm._s(result.city) + ",")]), _vm._v(" "), _c('span', {
      attrs: {
        "data-action": "ignore"
      }
    }, [_vm._v(_vm._s(result.state))]), _vm._v(" "), _c('span', {
      attrs: {
        "data-action": "ignore"
      }
    }, [_vm._v(_vm._s(result.zipcode))])]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };